<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form ref="form" @submit="validateAndSubmit" onSubmit="return false;">
          <v-card id="content_card">
            <v-card-title primary-title v-if="auth_request">
              <h3 class="headline mb-0">
                Authenticate for {{ auth_requester_title }}
              </h3>
            </v-card-title>

            <v-text-field
              type="email"
              class="input_field"
              v-model="mail"
              :rules="mail_rules"
              label="Your E-Mail Address"
            ></v-text-field>

            <v-text-field
              :append-icon="show_password ? 'visibility' : 'visibility_off'"
              class="input_field"
              :type="show_password ? 'text' : 'password'"
              v-model="password"
              :rules="password_rules"
              label="Your Password"
              @click:append="show_password = !show_password"
            ></v-text-field>

            <v-btn text small class="mb-4" v-on:click="reset_password"
              >Lost Your Password?</v-btn
            >
            <v-alert
              :value="show_alert"
              :type="alert_type"
              transition="scale-transition"
              >{{ alert_text }}</v-alert
            >
            <v-btn block rounded class="primary" type="submit" :loading="show_loading" :disabled="show_loading">Login</v-btn>

            <p class="text-center ma-4" style="font-size: x-large">
              <strong>or</strong>
            </p>

            <v-btn block rounded class="accent" v-on:click="go_to_signup" :disabled="show_loading"
              >Create New Account</v-btn
            >
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* global firebase */
import { mapActions } from "vuex";
export default {
  name: "SignIn",
  data() {
    return {
      show_alert: false,
      alert_type: "success",
      alert_text: "",
      show_loading: false,
      auth_request: this.$route.query.auth_requester > "",
      auth_requester: this.$route.query.auth_requester,
      show_password: false,
      mail: null,
      password: null,
      valid: null,
      mail_rules: [v => !!v || "E-Mail cannot be empty!"],
      password_rules: [v => !!v || "Password cannot be empty!"]
    };
  },
  methods: {
    ...mapActions("user", {
      login: "sign_in_with_password"
    }),
    async validateAndSubmit() {
      this.show_loading = false;
      this.show_alert = false;
      this.show_password = false;

      if (this.$refs.form.validate()) {
        this.show_loading = true;

        this.login({ mail: this.mail, password: this.password })
          .then(() => {
            this.alert_type = "success";
            this.alert_text = "Successfully Signed in!";
            this.show_alert = true;
            this.show_loading = false;
            this.$store
              .dispatch("user/load_profile", firebase.auth().currentUser)
              .then(() => {
                if (this.auth_request) {
                  this.$router.push({
                    name: "Authenticate Product",
                    query: {
                      auth_requester: this.auth_requester
                    }
                  });
                } else {
                  this.$router.push("/");
                }
              });
          })
          .catch(result => {
            this.show_loading = false;
            this.alert_type = "error";
            this.alert_text = result.message;
            this.show_alert = true;
          });
      }
    },
    go_to_signup() {
      this.$router.push({
        path: "/signup",
        query: {
          auth_requester: this.auth_requester,
          auth_requester_title: this.auth_requester_title
        }
      });
    },
    reset_password() {
      this.$router.push("/reset_password");
    }
  }
};
</script>

<style scoped>
#content_card {
  padding: 16px;
}
</style>
